exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-notice[data-v-06757dae] {\n  display: inline-block;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.header-notice span[data-v-06757dae] {\n  vertical-align: initial;\n}\n", ""]);

// exports
